import { render, staticRenderFns } from "./IpBlocklistComponent.vue?vue&type=template&id=6a471168&scoped=true"
import script from "./IpBlocklistComponent.vue?vue&type=script&lang=js"
export * from "./IpBlocklistComponent.vue?vue&type=script&lang=js"
import style0 from "./IpBlocklistComponent.vue?vue&type=style&index=0&id=6a471168&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a471168",
  null
  
)

export default component.exports